
import React from "react";

interface ProcessingNoticeProps {
  paymentDetails: {
    permitsCreated?: boolean;
    bookingsCreated?: boolean;
    paymentStatus?: string;
  } | null;
  title?: string;
  description?: string;
}

export const ProcessingNotice = ({ 
  paymentDetails, 
  title, 
  description 
}: ProcessingNoticeProps) => {
  // If custom title and description are provided, use them
  if (title && description) {
    return (
      <div className="w-full mb-4 p-3 bg-blue-50 border border-blue-100 rounded-md">
        <h3 className="font-medium text-blue-800 text-sm">{title}</h3>
        <p className="text-xs sm:text-sm text-blue-700">{description}</p>
      </div>
    );
  }

  // Default behavior for payment processing notice
  if (paymentDetails && !paymentDetails.permitsCreated && !paymentDetails.bookingsCreated && paymentDetails.paymentStatus === "paid") {
    return (
      <div className="w-full mb-4 p-3 bg-yellow-50 border border-yellow-100 rounded-md">
        <h3 className="font-medium text-yellow-800 text-sm">Important Notice:</h3>
        <p className="text-xs sm:text-sm text-yellow-700">
          Your payment was successful, but we're still processing your permits.
          Our system will create your permits shortly.
          Please check your email in a few minutes for your permit confirmation.
          Contact support with the transaction ID below if you don't receive your permits within 24 hours.
        </p>
      </div>
    );
  }

  return null;
};
